import React from 'react';

export default function BrandIcon({ name }) {
  switch (name) {
    case 'wifi':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12.55C6.97656 10.9036 9.46761 10.0021 12.04 10.0021C14.6124 10.0021 17.1034 10.9036 19.08 12.55"
            stroke="#3D3D3D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M1.42188 8.9993C4.3443 6.42327 8.10617 5.00195 12.0019 5.00195C15.8976 5.00195 19.6595 6.42327 22.5819 8.9993"
            stroke="#3D3D3D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M8.53125 16.1107C9.54645 15.3894 10.7609 15.002 12.0063 15.002C13.2516 15.002 14.466 15.3894 15.4812 16.1107"
            stroke="#3D3D3D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M12 20H12.01"
            stroke="#3D3D3D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      );

    default:
      <></>;
  }

  return <div></div>;
}
